/**
 * Author: Artyom Goncharov
 *   Team: Client-Core
 *   User: agoncharov
 *   Date: 20.05.2014
 *   Time: 12:11
 */

/**
 *
 */
export class LocalizedTimeFormatVO {
    public data: any[];

    /**
     * The VO holds formatting data for Localize.time utility
     *
     * @param t1_d
     * @param t1_h
     * @param t1_m
     * @param t1_s
     * @param t2_d
     * @param t2_h
     * @param t2_m
     * @param t3_d
     * @param t3_h
     * @param t4_d
     */
    // tslint:disable:variable-name
    constructor(
        t1_d: string = "",
        t1_h: string = "",
        t1_m: string = "",
        t1_s: string = "",
        t2_d: string = "",
        t2_h: string = "",
        t2_m: string = "",
        t3_d: string = "",
        t3_h: string = "",
        t4_d: string = ""
    ) {
        this.data = [[t1_d, t1_h, t1_m, t1_s], [t2_d, t2_h, t2_m, t1_s], [t3_d, t3_h, t2_m, t1_s], [t4_d, t3_h, t2_m, t1_s]];
    }
}
